import { SVGProps, Ref, forwardRef } from 'react';

export const ChevronArrowDownRightFilledSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    d="M8.839 5.861c-.137-.643-.218-1.375-.261-2.201h1.602c.041.729.112 1.344.223 1.868.199.93.51 1.5.95 1.888.45.399 1.129.69 2.225.874.551.091 1.187.153 1.922.19v1.706c-.735.038-1.37.1-1.922.191-1.096.183-1.775.475-2.225.873-.44.389-.751.958-.95 1.889-.11.522-.181 1.135-.223 1.861H8.579c.044-.823.124-1.553.26-2.195.233-1.092.642-1.991 1.366-2.672H5.3a4.8 4.8 0 0 1-4.8-4.8V1h1.6v4.333a3.2 3.2 0 0 0 3.2 3.2h4.904c-.724-.68-1.133-1.58-1.365-2.672"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
ChevronArrowDownRightFilledSize16Glyph.displayName = 'ChevronArrowDownRightFilledSize16Glyph';
